import * as React from 'react';
import { appInsights } from '../../AppInsights';
import styles from './Hocr.module.scss';

interface IShowhOcrProps {
    hOcrString: string;
    title: string;
    searchText: string;
}

export class ShowhOcr extends React.Component<IShowhOcrProps, {}> {

    public render() {
        return (
            <>
                {/* <div className='{styles.results}'>
                    <Icon name='angle down' />
                    <Icon name='angle up' />
                    1 of 4 results
                </div> */}
                <div className={styles.horc}>
                    {this.mark()}
                </div>

            </>
        );
    }


    private mark() {
        return this.getSrc().map((d, i) => {
            return this.generateImage(d, i);
        })


    }

    private getSrc(): string[] {

        var imageUrls: string[] = new Array;

        try {
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = this.props.hOcrString;
            var htmlString = htmlObject.getElementsByClassName('ocr_page');
            var title = htmlString[0].attributes.getNamedItem('title') || new Attr;
            for (let index = 0; index < htmlString.length; index++) {
                const element = htmlString[index];
                var title = element.attributes.getNamedItem('title') || new Attr;
                var start_pos = title.value.indexOf('"') + 1;
                var end_pos = title.value.indexOf('"', start_pos);
                var text_to_get = title.value.substring(start_pos, end_pos);
                imageUrls.push(text_to_get);
            }
        } catch (e) {
            let err = new Error("Get document image (ShowOcr): " + e);
            appInsights.trackException({
                exception: err,
                severityLevel: 3
            });
            console.error(err);
        }
        return imageUrls;
    }

    private generateImage(src: string, index: number) {
        return <img src={src} key={index} alt={this.props.title} />;
    }
}